import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material";

const CreateBookingModal = ({ open, onClose, onSave, availableTime }) => {
    const [userEmail, setUserEmail] = useState("");
    const [status, setStatus] = useState("");

    const handleSubmit = async () => {
        onSave({
            UserEmail: userEmail,
            AvailableTimeId: availableTime.Id,
            Status: status,
        });
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Create Booking</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="User Email"
                    type="email"
                    fullWidth
                    variant="outlined"
                    value={userEmail}
                    onChange={(e) => setUserEmail(e.target.value)}
                />
                <FormControl fullWidth>
                    <InputLabel>Status</InputLabel>
                    <Select
                        value={status}
                        label="Status"
                        onChange={(e) => setStatus(e.target.value)}
                    >
                        <MenuItem value={"confirmed"}>Confirmed</MenuItem>
                        <MenuItem value={"cancelled"}>Cancelled</MenuItem>
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSubmit}>Save Booking</Button>
            </DialogActions>
        </Dialog>
    );
};

export default CreateBookingModal;
